<label class="item-title"
  >Indian Registration Number
  <div class="item-element" data-cy="indianRegistrationNumber">
    <ng-container *ngIf="indianRegistration && indianRegistration.band">
      {{ indianRegistration?.band }}-{{ indianRegistration?.family }}-{{ indianRegistration?.position }}
    </ng-container>
    <ng-container *ngIf="!indianRegistration || !indianRegistration.band"> - </ng-container>
  </div>
</label>
